import client from "@/client/publicApiClient.ts";
import { useMutation } from "@tanstack/react-query";
import type { AcceptInvitationMutationResponse, AcceptInvitationPathParams, AcceptInvitation404 } from "../types/AcceptInvitation";
import type { UseMutationOptions } from "@tanstack/react-query";

 type AcceptInvitationClient = typeof client<AcceptInvitationMutationResponse, AcceptInvitation404, never>;
type AcceptInvitation = {
    data: AcceptInvitationMutationResponse;
    error: AcceptInvitation404;
    request: never;
    pathParams: AcceptInvitationPathParams;
    queryParams: never;
    headerParams: never;
    response: AcceptInvitationMutationResponse;
    client: {
        parameters: Partial<Parameters<AcceptInvitationClient>[0]>;
        return: Awaited<ReturnType<AcceptInvitationClient>>;
    };
};
/**
 * @summary Accept
 * @link /api/invitation/:inviteToken
 */
export function useAcceptInvitation(inviteToken: AcceptInvitationPathParams["inviteToken"], options: {
    mutation?: UseMutationOptions<AcceptInvitation["response"], AcceptInvitation["error"], AcceptInvitation["request"]>;
    client?: AcceptInvitation["client"]["parameters"];
} = {}) {
    const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};
    return useMutation({
        mutationFn: async () => {
            const res = await client<AcceptInvitation["data"], AcceptInvitation["error"], AcceptInvitation["request"]>({
                method: "post",
                url: `/api/invitation/${inviteToken}`,
                ...clientOptions
            });
            return res.data;
        },
        ...mutationOptions
    });
}